module.exports = __webpack_public_path__ + "static/img/newalogo.2235173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newalogo.png
// module id = xdw9
// module chunks = 1